export default "__VITE_ASSET__12787bd9__"